import {
  TextInput,
  Button,
  Group,
  Box,
  Text,
  NumberInput,
  Image as MantineImage,
  FileInput,
  Radio,
  Divider,
} from "@mantine/core";
import { useForm, zodResolver } from "@mantine/form";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowNarrowLeft, Upload } from "tabler-icons-react";

import {
  Category,
  categorySchema,
  useCategoryQuery,
  useChartsQuery,
  useUpdateCategoryMutation,
} from "services/api";
import getBase64 from "utils/getBase64";

const Edit = () => {
  const [updateCategory, { isLoading: isUpdatingCategory }] =
    useUpdateCategoryMutation();

  const { id } = useParams();
  const { data: category } = useCategoryQuery(id, { skip: id === undefined });

  const { data: chartsInCategory } = useChartsQuery({ categoryId: id });

  console.log({ chartsInCategory });

  const form = useForm<Category>({
    validate: zodResolver(categorySchema),
    initialValues: {
      id: 0,
      name: "",
      url: "",
      icon: "",
      sort: 0,
      display: 0,
    },
  });

  useEffect(() => {
    if (category === undefined) {
      return;
    }

    form.setValues({
      id: category.id,
      name: category.name,
      url: category.url ?? "",
      icon: category.icon ?? "",
      sort: category.sort ?? 0,
      display: category.display ?? 0,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  const navigate = useNavigate();

  const handleSubmit = async (values: Category) => {
    try {
      values.icon = values.iconFile
        ? await getBase64(values.iconFile)
        : values.icon;

      await updateCategory(values).unwrap();

      navigate("../categories", { replace: true });
    } catch (e) {}
  };

  return (
    <Box py={8} px={36}>
      <Text
        variant="link"
        component={Link}
        color="cyan"
        to="../categories"
        underline={false}
        sx={(theme) => ({
          display: "inline-flex",
          alignItems: "center",
          "&:hover": {
            borderBottom: "1px solid" + theme.colors.cyan[6],
          },
        })}
      >
        <ArrowNarrowLeft size={20} /> 返回上一頁
      </Text>
      <h2>編輯儀表板分類</h2>

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Box>
          <TextInput
            placeholder="名稱"
            required
            label="分類名稱"
            {...form.getInputProps("name")}
          />

          <TextInput
            placeholder='"/categories/自訂URL"，需注意網址限輸入數字及英文'
            label="分類網址 * 限輸入數字及英文"
            mt="sm"
            {...form.getInputProps("url")}
          />

          <FileInput
            label="分類圖示"
            required
            placeholder="請上傳透明且不大於 1MB 的 PNG/SVG 檔案，若 PNG 建議尺寸為 500x500"
            accept="image/svg+xml,image/png"
            icon={<Upload size={14} />}
            mt="sm"
            {...form.getInputProps("iconFile")}
          />

          <Text color="blue" size="xs" mt="xs">
            * 請上傳不大於1 MB之透明PNG/SVG檔案
          </Text>

          {form.values.iconFile ? (
            <MantineImage
              mt="sm"
              width={64}
              src={URL.createObjectURL(form.values.iconFile)}
              alt="category icon"
            />
          ) : (
            <MantineImage mt="sm" width={64} src={form.values.icon} />
          )}

          <Radio.Group
            my="md"
            label="資料顯示"
            required
            value={`${form.values.display}`}
            onChange={(value) => form.setFieldValue("display", +value)}
          >
            <Radio value="2" label="公開" />
            <Radio value="1" label="限市府人員" />
            <Radio value="0" label="隱藏下架" />
          </Radio.Group>

          <NumberInput
            label="排序"
            placeholder="1"
            {...form.getInputProps("sort")}
          />
        </Box>

        {chartsInCategory &&
          chartsInCategory.items &&
          chartsInCategory.items.length > 0 && (
            <>
              <Divider my="xs" label="已被歸類儀表板" />

              {chartsInCategory.items.map((x) => (
                <Text key={x.id}>{x.boardName}</Text>
              ))}
            </>
          )}

        <Group mt="xl">
          <Button type="submit" color="cyan" loading={isUpdatingCategory}>
            更新分類
          </Button>
        </Group>
      </form>
    </Box>
  );
};

export default Edit;
